var map = {
	"./de.json": 95894,
	"./en.json": 44174,
	"./fr.json": 94605,
	"./it.json": 83672,
	"./pt.json": 37741
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 72096;
module.exports = webpackAsyncContext;